import { globalData } from "@/data";
import { SWITCH_THEME } from "@/redux/types";

const initialState = { theme: globalData.themeTypes.light };

export const themeReducer = (state = initialState, action) => {
    const { type } = action;

    if (type === SWITCH_THEME) {
        return {
            ...state,
            theme: state.theme === globalData.themeTypes.light ? globalData.themeTypes.dark : globalData.themeTypes.light,
        };
    }

    return state;
};
